import { render, staticRenderFns } from "./CotTracciamentoChiamateEditPage.vue?vue&type=template&id=296f67bf"
import script from "./CotTracciamentoChiamateEditPage.vue?vue&type=script&lang=js"
export * from "./CotTracciamentoChiamateEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports